export const enum VirtualFileType {
  MULTI_PAGE_PDF = "pdf",
  REMOTE_FILE = "url",
  SINGLE_PAGE_IMAGE = "img",
  BINARY_PAGE_PDF = "page",
  PLOTTED_PAGE_PDF = "plot",
  ZIP_FILE = "zip",
}
